export default __webpack_public_path__ + "static/media/close-circle.0e0aa3a6.svg";